import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Gift, ChevronRight } from 'lucide-react';
import './Terms.css';

const Terms = () => {
  const navigate = useNavigate();

  const levels = [
    {
      id: 'bronze',
      name: 'Bronze',
      tagline: "C'est le statut avec lequel vous commencez",
      color: '#CD7F32',
      perks: [
        { pts: '100', desc: 'Recevez 100 KDO+ pour chaque 10 DT dépensés*' },
        { pts: '+300', desc: 'Bientôt ! À chaque commande d\'un montant minimum' },
        { pts: '+1 500', desc: 'Quand vous recommandez notre app à un ami' },
        { pts: null, desc: 'Accès aux récompenses membre Bronze' },
        { pts: null, desc: 'Offres personnelles réservées à l\'app !' }
      ]
    },
    {
      id: 'argent',
      name: 'Argent',
      tagline: 'Commandez pour 60 DT en 60 jours pour obtenir l\'Argent',
      color: '#94a3b8',
      bonus: '+10% de points en plus !',
      perks: [
        { pts: '110', desc: 'Recevez 110 KDO+ pour chaque 10 DT dépensés*' },
        { pts: '+500', desc: 'Quand vous passez en Argent' },
        { pts: '+250', desc: 'Quand vous maintenez votre Argent 60 jours' },
        { pts: null, desc: 'Accès aux récompenses membre Argent' },
        { pts: null, desc: 'Cadeau exclusif pour votre anniversaire !' }
      ]
    },
    {
      id: 'or',
      name: 'Or',
      tagline: 'Commandez pour 200 DT en 60 jours pour obtenir l\'Or',
      color: '#d97706',
      bonus: '+30% de points en plus !',
      perks: [
        { pts: '130', desc: 'Recevez 130 KDO+ pour chaque 10 DT dépensés*' },
        { pts: '+1 000', desc: 'Quand vous passez en Or' },
        { pts: '+500', desc: 'Quand vous maintenez votre Or 60 jours' },
        { pts: null, desc: 'Accès aux récompenses membre Or' },
        { pts: null, desc: 'Goodies exclusifs équipe KDO+ - Bientôt !' }
      ]
    },
    {
      id: 'diamant',
      name: 'Platine',
      tagline: 'Commandez pour 500 DT en 60 jours pour obtenir le Platine',
      color: '#2A2F6B',
      bonus: '+50% de points en plus !',
      perks: [
        { pts: '150', desc: 'Recevez 150 KDO+ pour chaque 10 DT dépensés*' },
        { pts: '+2 000', desc: 'Quand vous passez en Platine' },
        { pts: '+1 000', desc: 'Quand vous maintenez votre Platine 60 jours' },
        { pts: null, desc: 'Donnez vos KDO+ à une association ! - Bientôt !' },
        { pts: null, desc: 'Autocollant « Client VIP » - Bientôt !' },
        { pts: null, desc: 'Invitations aux événements réservés Platine - Bientôt !' },
        { pts: null, desc: 'Tirage au sort mensuel entre membres Platine - Bientôt !' }
      ]
    }
  ];

  return (
    <div className="terms-page">
      <header className="terms-header">
        <button className="terms-back-btn" onClick={() => navigate(-1)}>
          <ArrowLeft size={24} />
        </button>
        <h1 className="terms-title">Règles KDO+</h1>
        <p className="terms-intro">
          Gagnez des KDO+ à chaque achat (1 DT = 10 pts) et en scannant le QR code sur place.
          Échangez vos points contre des récompenses !
        </p>
      </header>

      <main className="terms-content">
        {levels.map((level) => (
          <section key={level.id} className="terms-level-card" style={{ borderTopColor: level.color }}>
            <div className="terms-level-header">
              <h2 className="terms-level-name" style={{ color: level.color }}>{level.name}</h2>
              <p className="terms-level-tagline">{level.tagline}</p>
              {level.bonus && (
                <span className="terms-level-bonus" style={{ background: level.color }}>{level.bonus}</span>
              )}
            </div>
            <ul className="terms-perks-list">
              {level.perks.map((perk, i) => (
                <li key={i} className="terms-perk">
                  {perk.pts && <span className="terms-pts">{perk.pts} KDO+</span>}
                  <span className="terms-desc">{perk.desc}</span>
                </li>
              ))}
            </ul>
          </section>
        ))}

        <section className="terms-disclaimer">
          <p>* Sous réserve des conditions en vigueur. Les montants et règles peuvent être modifiés.</p>
        </section>
      </main>

      <footer className="terms-footer">
        <Link to="/register-client" className="terms-cta">
          <Gift size={20} />
          Rejoindre le programme
        </Link>
        <Link to="/privacy" className="terms-link">
          Politique de confidentialité
          <ChevronRight size={18} />
        </Link>
      </footer>
    </div>
  );
};

export default Terms;
